import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import { useIsPortableDevice } from '@/modules/components/hooks/useIsPortableDevice'
import { useOneLink } from '@/modules/components/hooks/useOneLink'
import { useUserAgent } from '@/modules/components/hooks/useUserAgent'
import Link from '@/modules/components/Link'
import Typography from '@/modules/components/Typography'
import appStore from '@/modules/images/app_store.svg'
import playStore from '@/modules/images/play_store.svg'

export const DownloadButtons = () => {
  const userAgent = useUserAgent()
  const isIos = userAgent === 'ios'
  const isAndroid = userAgent === 'android'
  const neitherIosNorAndroid = !isIos && !isAndroid
  const { queryString } = useOneLink()
  const isMobileOrTablet = useIsPortableDevice()
  const { t } = useTranslation('navigation')

  return (
    <Flex alignItems="center">
      {(isAndroid || neitherIosNorAndroid) && (
        <Box
          customCss={{
            p: ['10px', '10px', '6px'],
            '&:hover': { background: '#1199F9' },
          }}
          border={'1.5px solid rgba(17, 153, 249, 0.5)'}
          borderRadius={'4px'}
          ml={1}
        >
          <Link href={`https://crypto.onelink.me/veNW${queryString}`}>
            <Flex alignItems={'center'}>
              <Box as="img" src={playStore} height={'24px'} />
              {isAndroid && (
                <Typography variant="submitBtn" ml={1}>
                  {t('products.app') as string}
                </Typography>
              )}
            </Flex>
          </Link>
        </Box>
      )}
      {(isIos || neitherIosNorAndroid) && (
        <Box
          customCss={{
            p: ['10px', '10px', '6px'],
            '&:hover': { background: '#1199F9' },
          }}
          border={'1.5px solid rgba(17, 153, 249, 0.5)'}
          borderRadius={'4px'}
          ml={1}
        >
          <Link href={`https://crypto.onelink.me/RSfq${queryString}`}>
            <Flex alignItems={'center'}>
              <Box as="img" src={appStore} height={'24px'} />
              {isIos && (
                <Typography variant="submitBtn" ml={1}>
                  {t('products.app') as string}
                </Typography>
              )}
            </Flex>
          </Link>
        </Box>
      )}
    </Flex>
  )
}
